var t = /* @__PURE__ */ ((T) => (T.ACCIDENT = "ACCIDENT", T.ADVICE = "ADVICE", T.AKA_CHILD = "AKA_CHILD", T.AKA_CRITICAL_ILLNESS = "AKA_CRITICAL_ILLNESS", T.AKA_FAMILY_ACCIDENT = "AKA_FAMILY_ACCIDENT", T.AKA_GROUP_LIFE = "AKA_GROUP_LIFE", T.AKA_HEALTH = "AKA_HEALTH", T.AKA_HEALTH_WITHOUT_SIGNING = "AKA_HEALTH_WITHOUT_SIGNING", T.AKA_HOUSE_CONTENTS = "AKA_HOUSE_CONTENTS", T.AKA_STUDENT = "AKA_STUDENT", T.AKA_TRAVEL = "AKA_TRAVEL", T.ANIMAL = "ANIMAL", T.BOAT = "BOAT", T.CABIN = "CABIN", T.CABIN_CONTENTS = "CABIN_CONTENTS", T.CAR = "CAR", T.CAR_NORSK_ELBILFORENING = "AUTO_NORSK_ELBILFORENING", T.CARAVAN = "CARAVAN", T.CHILD = "CHILD", T.CRITICAL_ILLNESS = "CRITICAL_ILLNESS", T.DEATH = "DEATH", T.DISABILITY_FLEX = "DISABILITY_FLEX", T.ELECTRIC_SCOOTER = "ELECTRIC_SCOOTER", T.HEALTH = "HEALTH", T.HEALTH_WITHOUT_SIGNING = "HEALTH_WITHOUT_SIGNING", T.HOUSE = "HOUSE", T.HOUSE_CONTENTS = "HOUSE_CONTENTS", T.HUSEIERNE_HOUSE_CONTENTS = "HUSEIERNE_HOUSE_CONTENTS", T.NEW_CHILD = "NEWCHILD", T.MOPED = "MOPED", T.MOTORCYCLE = "MOTORCYCLE", T.PREGNANT_AND_NEWBORN = "PREGNANT_AND_NEWBORN", T.RENTAL = "RENTAL", T.TRACTOR = "TRACTOR", T.SOP_SICKNESS_LEAVE = "SOP_SICKNESS_LEAVE", T.TRAILER = "TRAILER", T.TRAVEL = "TRAVEL", T.VALUABLES = "VALUABLES", T.VETERAN_AUTO = "VETERAN_AUTO", T))(t || {}), n = /* @__PURE__ */ ((T) => (T.LIFE = "LIFE", T.RISK = "RISK", T.HEALTH = "HEALTH", T))(n || {});
const o = () => {
  const { hostname: T } = window.location;
  return /^(www2|www|investor)\.(intra\.|partners\.)?storebrand\.no$/.test(
    T
  );
}, H = () => {
  const { hostname: T } = window.location;
  return T === "localhost";
}, O = () => {
  const { hostname: T } = window.location;
  return /^(www-t|www-ts)\./.test(T);
}, s = () => {
  const { hostname: T } = window.location;
  return T.includes("intra.storebrand");
}, r = () => {
  const { hostname: T } = window.location;
  return T.includes("partners.storebrand");
};
export {
  t as INSURANCE_NAME_VALUE,
  n as InsuranceType,
  s as isInternalHostname,
  H as isLocalhostHostname,
  r as isPartnersHostname,
  o as isProductionHostname,
  O as isTestHostname
};
